/**
 * @generated SignedSource<<e38ddf2719576f4559acff72c8218cb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoCategoryIcon = "Check" | "Message" | "Order" | "Sun";
export type TodoPriority = "DEFAULT" | "HIGH" | "LOW" | "URGENT";
import { FragmentRefs } from "relay-runtime";
export type TeamFeatureBarTodoCategoryItem_todoCategoryTeam$data = {
  readonly category: {
    readonly icon: TodoCategoryIcon | null;
    readonly id: string;
    readonly title: string;
  };
  readonly hasExpiredTodos: boolean;
  readonly id: string;
  readonly notResolvedCount: number;
  readonly todoActiveAssignedCount: number;
  readonly todoHighestPrio: TodoPriority | null;
  readonly " $fragmentType": "TeamFeatureBarTodoCategoryItem_todoCategoryTeam";
};
export type TeamFeatureBarTodoCategoryItem_todoCategoryTeam$key = {
  readonly " $data"?: TeamFeatureBarTodoCategoryItem_todoCategoryTeam$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamFeatureBarTodoCategoryItem_todoCategoryTeam">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "employeeId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamFeatureBarTodoCategoryItem_todoCategoryTeam",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "notResolvedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "employeeId",
          "variableName": "employeeId"
        }
      ],
      "kind": "ScalarField",
      "name": "todoActiveAssignedCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExpiredTodos",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "todoHighestPrio",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "icon",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TodoCategoryTeam",
  "abstractKey": null
};
})();

(node as any).hash = "89b5bbf070e734f12207b26da21b5981";

export default node;
